"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "main-settings-container" };
const _hoisted_2 = {
    key: 0,
    class: "settings-card-container"
};
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "settings-title-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "page-title-text" }, "退会")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "settings-item" };
const _hoisted_5 = { class: "settings-item-name-wrapper flex-center" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "settings-item-name" }, "退会手続き", -1 /* HOISTED */);
const _hoisted_7 = {
    class: "tooltip-container",
    tabindex: "0"
};
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "tooltip-wrapper" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-text" }, "シフトや従業員情報を含むすべてのデータが削除されます。")
], -1 /* HOISTED */);
const _hoisted_9 = { class: "settings-input oplus-form-switch" };
const _hoisted_10 = ["href"];
const InfoIcon_vue_1 = __importDefault(require("../icons/InfoIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SettingsOthersContent',
    props: {
        isDefaultSettingsPage: {
            type: Boolean,
            default: false,
        },
        userId: {
            type: String,
            required: true,
        }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (__props.isDefaultSettingsPage)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        _hoisted_3,
                        (0, vue_2.createCommentVNode)(" apiRemoveExisting "),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                _hoisted_6,
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_2.createVNode)(InfoIcon_vue_1.default, { class: "show-sm" }),
                                    _hoisted_8
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("label", _hoisted_9, [
                                (0, vue_2.createElementVNode)("a", {
                                    href: `/dashboard/${__props.userId}/deactivate`,
                                    class: "oplus-btn oplus-btn-error-alt"
                                }, "退会", 8 /* PROPS */, _hoisted_10)
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ]));
        };
    }
});
